import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { formValueSelector } from "redux-form";
import { FormattedMessage } from "react-intl";
import moment from "moment";

import BillingPeriodField from "../BillingPeriodField";

class TaxBenefitsForm extends React.Component {
  filterBillingPeriods(startId) {
    const startDate =
      startId && startId != " "
        ? this.props.billingPeriods.find((p) => p.billingPeriodId == startId)
            .startDate
        : null;

    return this.props.billingPeriods.filter((billingPeriod) => {
      return !startDate || moment(billingPeriod.startDate) >= moment(startDate);
    });
  }

  render() {
    const { billingPeriods, startingBillingPeriodId } = this.props;

    return (
      <div>
        <BillingPeriodField
          id="startingBillingPeriodId"
          name="startingBillingPeriodId"
          billingPeriods={billingPeriods}
          label={
            <FormattedMessage id="clients.client.reports.taxBenefits.form.startingBillingPeriod" />
          }
        />

        {startingBillingPeriodId && (
          <BillingPeriodField
            id="endingBillingPeriodId"
            name="endingBillingPeriodId"
            billingPeriods={this.filterBillingPeriods(startingBillingPeriodId)}
            label={
              <FormattedMessage id="clients.client.reports.taxBenefits.form.endingBillingPeriod" />
            }
          />
        )}
      </div>
    );
  }
}

TaxBenefitsForm.propTypes = {
  billingPeriods: PropTypes.array.isRequired,
  startingBillingPeriodId: PropTypes.string,
};

const selector = formValueSelector("clientReportsForm");

function mapStateToProps(state) {
  return {
    startingBillingPeriodId: selector(state, "startingBillingPeriodId"),
  };
}

export default connect(mapStateToProps, null, null, {
  withRef: true,
})(TaxBenefitsForm);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/reports/forms/taxBenefits/taxBenefitsForm.js